module.exports = __webpack_public_path__ + "static/media/HeaderComponent_elN2009Copy_581687.defbc9c2.jpg";